// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"73aff31a","40":"1a1188c1","177":"90a4bb3e","252":"e0fdd6ea","357":"e62c6897"}[chunkId] + ".chunk.js";
};